<template>

<DialogBox :settings="settings" :disabled="!isFormValid" @save="save" @show="showingDialog" @hide="hidingDialog">
    <div style="position:relative" class="pr-4 pl-4 pb-4">   
        <v-text-field v-model="action.name" label="Action Name"/>
        <v-text-field v-model="action.field" label="Field" />
        <v-select v-model="action.type" :items="actionTypes" item-text="name" item-value="name" label="Action Type" />
        <v-text-field v-model="action.expression" label="Expression" />
        <v-container fluid>
        <v-checkbox v-model="action.operationCreate" single-line hide-details label="Create"></v-checkbox>
        <v-checkbox v-model="action.operationUpdate" single-line hide-details label="Update"></v-checkbox>
        <v-checkbox v-model="action.operationDelete" single-line hide-details label="Delete"></v-checkbox>
        </v-container>
    </div>
    <div slot="footer">
        <DeleteButton v-if="this.action._id"  @delete="deleteButtonClicked" style="float:left"></DeleteButton>
    </div>
</DialogBox>

</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import MergeHelpers from '../helpers/MergeHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import LookupData from '../helpers/LookupData'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'

import DeleteButton from '../ui-elements/DeleteButton'


import DialogBox from '../ui-elements/DialogBox'
import ContactHelpers from '../helpers/ContactHelpers'


export default {
props:{
    settings: Object,
    action: Object,
},
components:{
    DialogBox,
    DeleteButton,
},
data() {
    return {
        
    }
},
computed: {

    isFormValid() {
        return true
    },

    actionTypes() {
        return LookupData.actionTypes
    },

},
methods: {

    save() {
        this.$emit('save', this.action)
        this.settings.visible = false
    },


    showingDialog() {
        // if(!this.action.operation)
        //     this.action.operation = {}
    },

    hidingDialog() {
        setTimeout( () => { 
            
        }, 300)            
    },

    deleteButtonClicked() {
        this.$emit('delete', this.action)
        this.settings.visible = false
    },

    setIdentifier() {
        if(!this.action.identifier && this.action.name)
            this.$set(this.action, 'identifier', StringHelpers.toCamelCase(this.action.name) )
    }

},

created() {
    this.settings.height = '350px'
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// ActionDialog.vue?66607134